const INITIAL_STATE = {
    esperandoSolicitacao: false,
    instituicoes: null,
    filterInstituicao: '',
    totalInstituicoes: null,
    totalInstituicoesFiltro: null,
    tipoOrdenacaoSelecionada: '',
    error: false,
    mensagem: ''  
};

export default (state = INITIAL_STATE, action) => {

    switch (action.type) {

        case 'DADOS_INSTITUICOES_RECEBIDOS':            
            return { ...state, esperandoSolicitacao: false, error: false, mensagem: '', instituicoes: action.payload, totalInstituicoes: action.payload.length };
            
        case 'DADOS_INSTITUICOES_SOLICITADOS':
            return { ...state, esperandoSolicitacao: true, mensagem: '', error: false }; 

        case 'ERRO_INSTITUICOES_RECEBIDO':
                return { ...state, esperandoSolicitacao: false, mensagem: 'erro_instituicoes', error: true };    

        case 'INSTITUICAO_LIMPAR_MENSAGEM':
            return { ...state, esperandoSolicitacao: true, error: false, mensagem: ''};

        case 'CONSULTA_FILTER_NOME':
            return {...state, filterInstituicao: action.payload, tipoOrdenacaoSelecionada: '', error: false};

        case 'TOTAL_INSTITUICOES_FILTRO_ATUALIZADO':
            return {...state, totalInstituicoesFiltro: action.payload, error: false};

        case 'ORDENACAO_SELECIONADA':
            return {...state, tipoOrdenacaoSelecionada: action.payload, error: false};

        default:
            return state;
    }
}
